import { supabase } from "./supabase";

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN;

export async function establishApiSession(accessToken?: string): Promise<void> {
  const token = accessToken ?? (await supabase.auth.getSession()).data.session?.access_token;

  if (!token) {
    throw new Error("Missing access token");
  }

  const response = await fetch(`${API_DOMAIN}/api/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ access_token: token }),
  });

  if (!response.ok) {
    throw new Error("Failed to establish session");
  }
}
